import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stbyDaysUntilDatePipe',
})
export class DaysUntilDatePipe implements PipeTransform {
    transform(value: string | Date): number {
        if (typeof value === 'string') {
            const date = new Date(value);
            return this.daysLeftFromNow(date);
        }
        return this.daysLeftFromNow(value);
    }

    private daysLeftFromNow(date: Date): number {
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        date.setHours(0, 0, 0, 0);

        const difference = date.getTime() - now.getTime();
        const daysLeft = Math.ceil(difference / (1000 * 60 * 60 * 24));

        return daysLeft;
    }
}
